module.exports = __webpack_public_path__ + "img/espacos.c9c34f82.jpeg";